import Conversations from '@forwardflow/pages/Conversations'
import { useGetDefaultConfigurations } from "@forwardflow/hooks/customHooks/useGetDefaultConfigurations";
import DemoConversations from "@forwardflow/pages/DemoConversations";

const DemoConversationLayout = () => {
  const { data } = useGetDefaultConfigurations()
  return (
    <>
      {data?.featureFlags?.enableNewDemoConversation === true ? (
        <DemoConversations />
      ) : (
        <Conversations />
      )}
    </>
  );
};

export default DemoConversationLayout;
